<template>
  <div class="col d-flex flex-row-reverse">
    <div :class="[
        'alert alert-dismissible fade show custom-alert',
        alert[link]
      ]"
         role="alert"
         v-if="isVisible"
    >
      {{ message }}
      <button
          type="button"
          class="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
          @click="$emit('onVisible', false)"
      ></button>
    </div>
  </div>
</template>

<style>
.custom-alert {
  position: fixed !important;
  right: 20px;
  bottom: 20px;
  z-index: 9999;
}
</style>

<script>
export default {
  props: {
    message: {
      type: String
    },
    link: {
      type: String,
      default: 'success'
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    time: {
      default: 5000
    }
  },

  emits: ['onVisible'],

  data() {
    return {
      alert: {
        primary: 'alert-primary',
        secondary: 'alert-secondary',
        success: 'alert-success',
        danger: 'alert-danger',
        warning: 'alert-warning',
        info: 'alert-info',
        dark: 'alert-dark'
      }
    }
  },

  watch: {
    isVisible(val) {
      if (val) {
        const self = this;
        setTimeout(function () {
          self.$emit('onVisible', false);
        }, self.time);
      }
    }
  }
}
</script>